import { Record } from 'immutable';

const ShortAnswerRecord = Record({
  name: undefined,
  studentId: undefined,
  submitBy: undefined,
  submitDate: undefined,
  status: undefined,
  statusDisplayName: undefined,
  comment: undefined,
  commentBy: undefined,
  commentDate: undefined,
  shortAnswers: undefined,
});

class ShortAnswer extends ShortAnswerRecord {}

export default ShortAnswer;



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/model/model.js